var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Options")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "link"
    }
  }, [_vm._v("Link")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("With Icons")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("  Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v("  Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _vm._v("  Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("  Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss"
  }), _vm._v("  Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("  Link")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Size Large")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"lg\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "danger"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "link"
    }
  }, [_vm._v("Link")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Size Small")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"sm\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "link"
    }
  }, [_vm._v("Link")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Disabled state")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v(":disabled=\"true\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "primary",
      "disabled": true
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "secondary",
      "disabled": true
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "success",
      "disabled": true
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "info",
      "disabled": true
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "warning",
      "disabled": true
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "danger",
      "disabled": true
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "link",
      "disabled": true
    }
  }, [_vm._v("Link")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Active state")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v(":active=\"true\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "active": true
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "secondary",
      "active": true
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success",
      "active": true
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "info",
      "active": true
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "warning",
      "active": true
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger",
      "active": true
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "link",
      "active": true
    }
  }, [_vm._v("Link")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Block Level Buttons")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v(":block=\"true\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "secondary",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "primary",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "success",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "info",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "warning",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "danger",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "link",
      "block": true
    }
  }, [_vm._v("Block level button")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Options")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger"
    }
  }, [_vm._v("Danger")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("With Icons")])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("  Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v("  Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-success"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _vm._v("  Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("  Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss"
  }), _vm._v("  Danger")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Size Large")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"lg\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-danger"
    }
  }, [_vm._v("Danger")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Size Small")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("size=\"sm\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    }
  }, [_vm._v("Danger")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Disabled state")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v(":disabled=\"true\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "disabled": true
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "disabled": true
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": true
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-info",
      "disabled": true
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-warning",
      "disabled": true
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "disabled": true
    }
  }, [_vm._v("Danger")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Active state")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v(":active=\"true\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "active": true
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "active": true
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-success",
      "active": true
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-info",
      "active": true
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-warning",
      "active": true
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "active": true
    }
  }, [_vm._v("Danger")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Block Level Buttons")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v(":block=\"true\"")])])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-secondary",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-primary",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-success",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-info",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-warning",
      "block": true
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-danger",
      "block": true
    }
  }, [_vm._v("Block level button")])], 1)], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3eda38e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/Buttons.vue
// module id = 784
// module chunks = 1